<wo-details-wrapper>
  <div class="wo-download-template-content">
    <div class="wo-download-template-info">
      <div class="wo-download-template-title">{{ label }}</div>
      <div class="wo-download-template-subtitle"><ng-content/></div>
    </div>
    <div>
      <wo-download-button (download)="download.emit()" [processing]="loading">
        {{ btnLabel }}
      </wo-download-button>
    </div>
  </div>
</wo-details-wrapper>
